import { Card, webOnlyStyles, fromTheme, styled, Text, View, Button } from 'lib_ui-primitives';

export const ConfirmationCard = webOnlyStyles(Card)`
    box-shadow: unset;
    max-width: ${fromTheme('modal', 'confirmation', 'maxWidth')};
    padding: 0 8px;
    flex-grow:0;
`;
ConfirmationCard.displayName = 'ConfirmationCard';

export const CardHeader = styled(Card.Header)`
    padding: ${fromTheme('modal', 'header', 'padding')};
    flex-direction: column;
    gap: ${fromTheme('modal', 'header', 'gap')};
`;
CardHeader.displayName = 'CardHeader';

export const HeaderText = styled(Text)`
    ${fromTheme('card', 'header', 'font')};
`;
HeaderText.displayName = 'HeaderText';

export const Body = styled(Card.Body)`
    padding: ${fromTheme('modal', 'body', 'padding')};
    flex-direction: column;
    align-items: flex-start;
    ${fromTheme('card', 'body', 'font')};
`;
Body.displayName = 'CardBody';

let _Content = styled(Text)`
    ${fromTheme('card', 'body', 'font')};
`;

export const Content = webOnlyStyles(_Content)`
    margin-block-start: 0;
    margin-block-end: 0;
    word-wrap: break-word;
`;
Content.displayName = 'Content';

export const ButtonBar = styled(View)`
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
    flex-direction: ${({ theme: { mobile } }) => (mobile ? 'column-reverse' : 'row')};
    align-items: ${({ theme: { mobile } }) => (mobile ? 'stretch' : 'center')};
    justify-content: flex-end;
    width: 100%;
`;
ButtonBar.displayName = 'ButtonBar';

export const DialogButton = styled(Button)`
    display: flex;
    flex-grow: 1;
    width: auto !important;
    min-width: ${fromTheme('modal', 'button', 'minWidth')};
    max-width: ${fromTheme('modal', 'button', 'maxWidth')};
    justify-content: center;
`;
DialogButton.displayName = 'DialogButton';
